import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip,
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import * as Yup from "yup";
import { useFormik } from "formik";
import CustomDatePicker from "common/CustomDatePicker";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { changeEmployeeExemptionStatus, fetchEmployeeDropdownAutoList, fetchEmployees, getEmployeeExemptions, saveEmployeeExemption } from "store/actions";
import Loader from "common/pageLoader";
import { Link } from "@mui/material";
import Swal from "sweetalert2";
import CustomSelect from "components/Common/custom-select";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const EmployeeExemption = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    exemptionlist,
    dropdownAutoList,
    employees,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    exemptionlist: state.EmployeeExemptionReducer?.exemptionlist ?? [],
    employees: state.EmployeeDetailsReducer?.employees ?? [],
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],

    loading: state.EmployeeExemptionReducer?.loading || state.EmployeeDetailsReducer?.loading,
    error: state.EmployeeExemptionReducer?.error || state.EmployeeDetailsReducer?.error,
    success: state.EmployeeExemptionReducer?.success,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(getEmployeeExemptions(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId))
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(getEmployeeExemptions(authDetails?.unit_id));
    }
  }, [authDetails, success, dispatch]);


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      employee: "",
      effectiveFrom: "",
      reason: "",
    },
    validationSchema: Yup.object({
       employee: Yup.object()
        .nullable()
        .required("Employee is required"),

      effectiveFrom: Yup.string()
        .nullable()
        .required("Effective From date is required"),

      reason: Yup.string()
        .nullable()
        .required("Reason is required").max(200, "Reason must not exceed 200 characters"),
    }),
    onSubmit: (values, { resetForm }) => {
      const payload = new FormData();
      payload.append("emp_id", values.employee?.value);
      payload.append("effect_from", values.effectiveFrom);
      payload.append("reason", values.reason);
      payload.append("create_by", authDetails?.user_id);
      dispatch(saveEmployeeExemption(payload))
      formik.resetForm();
    },
  });

  const columns = [
    ...(canEdit || canCreate
    ? [
        {
          Header: "Action",
          // accessor: "emp_status",
          Cell: (cellProps) => {
            const { emp_status, emp_id, emp_no } = cellProps.row.original;
            const isActive = emp_status === 1;

            return (
              <div className="d-flex gap-3 justify-content-center">
                <Link
                  to="#"
                  style={{ color: isActive ? "green" : "red" }}
                  onClick={() =>
                    handleToggleStatus(emp_id, emp_no, isActive)
                  }
                >
                  <i
                    className={`mdi ${
                      isActive ? "mdi-check-circle" : "mdi-close-circle"
                    } font-size-18`}
                    id={`status-tooltip-${emp_no}`}
                  />
                </Link>

                <UncontrolledTooltip
                  placement="top"
                  target={`status-tooltip-${emp_no}`}
                >
                  {isActive ? "Active" : "Inactive"}
                </UncontrolledTooltip>
              </div>
            );
          },
        },
      ]
    : []),
    {
      Header: "S.No",
      className: "serial-no",
      applyHeaderClass: true,
      Cell: ({ row }) => exemptionlist.length - row.index,
    },
    {
      Header: "Code",
      accessor: "emp_no",
    },
    {
      Header: "Name",
      accessor: "emp_name",
    },
    {
      Header: "Effective Date",
      accessor: "effect_from",
    },
    {
      Header: "Reason",
      accessor: "reason",
    },
    {
      Header: "Created By",
      accessor: "created_by",
    },
    {
      Header: "Created On",
      accessor: "created_dt",
    },
    // {
    //   Header: "Status",
    //   accessor: "emp_status",
    //   Cell: (cellProps) => {
    //     const { emp_status, emp_id, emp_no, emp_name } = cellProps.row.original;
    //     const isActive = emp_status === 1; // Status 1 = Active
    //     return (
    //       <div className="d-flex gap-3">
    //         {/* Status Toggle */}
    //         <Link
    //           to="#"
    //           style={{ color: isActive ? 'green' : 'red' }}
    //           onClick={() => handleToggleStatus(emp_id, emp_no, isActive)}
    //         >
    //           <i
    //             className={`mdi ${isActive ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
    //             id={`status-tooltip-${emp_no}`}
    //           />
    //           <UncontrolledTooltip placement="top" target={`status-tooltip-${emp_no}`}>
    //             {isActive ? 'Active' : 'Inactive'}
    //           </UncontrolledTooltip>
    //         </Link>
    //       </div>
    //     );
    //   },
    // },
    
  ];

  const handleToggleStatus = (EmpId, emp_no, isActive) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to ${isActive ? 'deactivate' : 'activate'} ${emp_no} exemption.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("emp_id", EmpId);
        formData.append("create_by", authDetails?.user_id);
        dispatch(changeEmployeeExemptionStatus(formData));
      }
    });
  };

  const handleCancel = async (e) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "All entered data will be cleared.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      confirmButtonColor: "rgb(145, 73, 234)",
      cancelButtonColor: "#6c757d",
    });

    if (!result.isConfirmed) return;

    formik.resetForm({
      values: {
        employee: null,
        effectiveFrom: "",
        reason: "",
      },
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading} />
        <Container fluid>
          {/* Breadcrumbs */}
          <Breadcrumbs title="Employee" breadcrumbItem="Employee Exemption" />

          {/* Input Section */}
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="mb-3 g-md-2 g-lg-2 g-xl-3">
                  <Col md="4">
                    <FormGroup>
                      <Label for="employee">
                        Employee <span className="text-danger">*</span>
                      </Label>
                      <CustomSelect
                        id="employee"
                        name="employee"                        
                        options={dropdownAutoList.map(emp => ({ value: emp.emp_id, label: emp.emp_no }))}
                        value={formik.values.employee || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                      />
                      {formik.touched.employee && formik.errors.employee && (
                        <div className="text-danger">
                          {formik.errors.employee}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="effectiveFrom">
                        Effective From <span className="text-danger">*</span>
                      </Label>
                      {/* <Input
                        id="effectiveFrom"
                        name="effectiveFrom"
                        type="date"
                        value={formik.values.effectiveFrom}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.effectiveFrom &&
                          Boolean(formik.errors.effectiveFrom)
                        }
                      /> */}
                      <CustomDatePicker
                        value={formik.values.effectiveFrom}
                        onChange={(date) => formik.setFieldValue("effectiveFrom", date)}
                        onBlur={() => formik.setFieldTouched("effectiveFrom", true)}
                        disablePast={true}
                      />
                      {formik.touched.effectiveFrom &&
                        formik.errors.effectiveFrom && (
                          <div className="text-danger">
                            {formik.errors.effectiveFrom}
                          </div>
                        )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="reason">
                        Reason <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="reason"
                        name="reason"
                        type="textarea"
                        maxLength={200}
                        value={formik.values.reason}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        
                        style={{ height: "36.16px" }}
                      />
                      {formik.touched.reason && formik.errors.reason && (
                        <div className="text-danger">
                          {formik.errors.reason}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="12" className="d-flex mob-center align-items-center justify-content-end mt-2">
                    {/* <Button type="submit" className="btn button-save  me-2">
                      <i className="fas fa-save me-1" /> Save
                    </Button>
                    <Button
                      type="button"
                      onClick={formik.handleReset} className="btn button-cancel"> <i className="fas fa-sync me-1" /> Cancel
                    </Button> */}
                    {/* SAVE — Only Create */}
                    {canCreate && (
                      <Button type="submit" className="btn button-save me-2">
                        <i className="fas fa-save me-1" /> Save
                      </Button>
                    )}

                    {/* CANCEL — Show for all modes except Delete-only */}
                    {(canRead || canEdit || canCreate || canDelete) && (
                      <Button
                        type="button"
                        onClick={handleCancel}
                        className="btn button-cancel"
                      >
                        <i className="fas fa-sync me-1" /> Cancel
                      </Button>
                    )}
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>

          {/* Table Section */}
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={exemptionlist.length > 0 ? exemptionlist : []}
                isGlobalFilter={true}
                customPageSize={10}
                className="table-striped"
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EmployeeExemption;
